export default {
  data() {
    return {
      activeStar: this.$route.query.star || null
    }
  },
  methods: {
    setActiveStar(value) {
      this.activeStar = value

      // update query params
      const query = Object.assign({}, this.$route.query);

      delete query.star;

      query.page = 1;

      if (this.$route.query !== query) {
        // to avoid duplicate navigation
        this.$router.push({ query: query })
      }
    }
  },
  watch: {
    activeStar(newValue) {
      const query = Object.assign({}, this.$route.query, { star: newValue });

      if (!newValue || newValue == '-1') {
        delete query.star;
      }

      const sameNumOfParams = Object.keys(this.$route.query).length === Object.keys(query).length

      if (sameNumOfParams) {
        const sameParams = Object.keys(this.$route.query).every(key => this.$route.query[key] === query[key])
        if (!sameParams) {
          this.$router.push({ query: query })
        }
      } else {
        this.$router.push({ query: query })
      }
    }
  }
}
